module.exports = __webpack_public_path__ + "img/icon_logo_white.c96457a6.png";